<template>
	<header class="masthead">
		<div class="container">
			<div class="intro-text">
				<div class="intro-lead-in">Bien connaître le milieu de l'informatique</div>
				<div class="intro-heading text-uppercase">Decouvrir chaque métier</div>
				<a class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#informatique">Savoir Plus</a>
			</div>
		</div>
	</header>	
</template>

<script>
export default {

}
</script>

<style lang="css">

</style>


